module.exports = __webpack_public_path__ + "static/media/last-accesses-1.ae935618.png";